import RoleLevelModelingPage from "./role-level-modeling-page.jsx";

export default RoleLevelModelingPage;